<template>
    <div class="banner-timer-counter" v-if="timerShow">
        <div class="banner-timer-container" :style="{width:`${vWidth}px`}">
            <!-- <div v-if="label" v-html="label" class="banner-timer-label"></div> -->
            <div class="banner-clock">
                <div class="hours">{{hours | numberFormat}}</div>
                <div class="sep">:</div>
                <div class="mins">{{mins | numberFormat}}</div>
                <div class="sep">:</div>
                <div class="secs">{{secs | numberFormat}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import timer from '@/Utilities/timer';
export default {
    props:{
        timeCounter:{
            type: Number,
            default: 0
        },
        label:{
            type: String,
            default: null
        },
        vWidth:{
            type: Number,
            default: 365
        }
    },
    data(){
        return {
            timerShow: false,
            hours: '',
            mins: '',
            secs: ''
        }
    },
    mounted() {
        if(this.timeCounter){
            // this isn't added to component "data" because we don't need reactivity, just old plain variable
            this.dateEnd = (new Date(this.timeCounter * 1000)).getTime();
            this.setVar();
        }
    },
    methods: {
        setVar() {
            //let calc = timer.calcTimerCounter(this.timeCounter);
            const calc = timer.getTimerData(this.dateEnd);
            if(!calc){
                this.timerShow = false;
                return;
            }
            this.secs = calc.secs;
            this.mins = calc.mins;
            this.hours = calc.hours;
            this.timerShow = true;
            setTimeout(() => {this.setVar();}, 1000);
        }
    },
    filters: {
        numberFormat(value){
            return timer.formatNumberCounter(value);
        }
    }
}
</script>